import { autocomplete } from './autocomplete';
import { avatar } from './avatar';
import { datepicker } from './date-picker';
import { checkbox } from './checkbox';
import { chip } from './chip';
import { datatable } from './data-table';
import { editor } from './editor';
import { image } from './image';
import { floatlabel } from './float-label';
import { global } from './global';
import { inputgroup } from './input-group';
import { inputgroupaddon } from './input-group-addon';
import { inputtext } from './input-text';
import { menu } from './menu';
import { multiselect } from './multi-select';
import { popover } from './popover';
import { select } from './select';
import { skeleton } from './skeleton';
import { tieredmenu } from './tiered-menu';
import { paginator } from './paginator';
import { toast } from './toast';

export const PrimeVuePt = {
  autocomplete,
  avatar,
  checkbox,
  chip,
  datatable,
  datepicker,
  editor,
  image,
  floatlabel,
  global,
  inputgroup,
  inputgroupaddon,
  inputtext,
  menu,
  multiselect,
  popover,
  select,
  skeleton,
  tieredmenu,
  paginator,
  toast,
};
